import React from "react";

export default function Cookies() {
  return (
    <main className="max-w-4xl mx-auto px-6 lg:px-10 py-16" data-testid="cookies-page">
      <div className="overline">Legal</div>
      <h1 className="font-serif text-4xl md:text-5xl tracking-tighter mt-3 mb-8">
        Cookie Notice
      </h1>
      <p className="text-zinc-400 text-sm mb-10">Last updated: August 2026</p>

      <div className="prose prose-invert max-w-none space-y-6 text-zinc-300 leading-relaxed">
        <section>
          <p>
            Cookies are small text files stored on your device by websites you visit.
            Jacinto's Culinary Atelier uses a minimal set of cookies — only what is
            necessary to operate the site and, with your consent, understand traffic.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">Essential cookies (always on)</h2>
          <p>These are required for the site to function and cannot be disabled.</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Session token</b> — keeps you signed in</li>
            <li><b>Language preference</b> — remembers your chosen language</li>
            <li><b>Stripe</b> — secures the payment flow</li>
            <li><b>Cloudflare</b> — protects against attacks</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">Analytics cookies (with consent)</h2>
          <p>
            Only active if you accept them in the banner. Help us understand how
            visitors use the atelier so we can improve it.
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Google Analytics 4</b> — anonymised page-view and interaction data</li>
          </ul>
          <p>
            You can withdraw consent at any time by clicking "Cookie preferences" in the
            footer.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">Managing cookies in your browser</h2>
          <p>
            You can also delete or block cookies via your browser settings. See the help
            pages for your browser (Chrome, Safari, Firefox, Edge) for step-by-step
            guidance.
          </p>
        </section>

        <section>
          <h2 className="font-serif text-2xl gold mb-3">Questions</h2>
          <p>
            Email{" "}
            <a href="mailto:jacintof.samuel@gmail.com" className="gold underline">
              jacintof.samuel@gmail.com
            </a>{" "}
            with any question about cookies or data.
          </p>
        </section>
      </div>
    </main>
  );
}
